import { Injectable } from '@angular/core';
import { IError } from '../types';
import { PopNotificationService } from './pop-notification.service';
import * as commonTypes from '../types';
import * as StackTrace from 'stacktrace-js';

@Injectable()
export class LoggingService {

  constructor(private notificationSvc: PopNotificationService) { }

  public logError( error: IError ): void {
    // Internal tracking.
    this.sendToConsole( error );
    this.popNotification( error );
    // this.sendToServer( error );

    // Software-as-a-Service (SaaS) tracking.

  }

  // I send the error the browser console (safely, if it exists).
  private sendToConsole(error: IError): void {
    if ( console && console.group && console.error ) {
      console.group( 'Error Log Service' );
      console.error( error.url );
      console.error( error.message );
      console.error( error.stack );
      console.groupEnd();
    }
  }

  private popNotification(error: IError): void {
    const errorObj: commonTypes.IToastr = {
        type: 'error',
        title: error.message,
        body: error.stack
    };
    this.notificationSvc.popNotification(errorObj);
  }

  public getStackASync(error: any, numberOfStackItems: number): Promise<string> {

    return StackTrace.fromError(error).then(stackframes => {
      return stackframes
        .splice(0, numberOfStackItems)
        .map(function(sf) {
          return sf.toString();
        }).join('\n');

    });
  }

  public getStackSync(numberOfStackItems: number): string {
    return StackTrace.getSync().splice(0, numberOfStackItems).map(sf => sf.toString()).join('\n');
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/logging.service.ts